import React, {useEffect} from 'react';
import {BsPatchCheckFill} from 'react-icons/bs';
import {AiFillHtml5} from 'react-icons/ai';
import {DiCss3, DiJavascript, DiNodejsSmall,} from 'react-icons/di';
import {SiMongodb, SiPhp} from 'react-icons/si';
import {DiReact} from 'react-icons/di';
import './Experience.css';
import Aos from 'aos';
import "aos/dist/aos.css";


const Experience = () => {
  useEffect(() => {
    Aos.init({duration: 1000});
  },[]);

  
  return (
    <section id="experience"> 
      <h5 data-aos="fade-in"> My Skills </h5>
      <h2 data-aos="fade-in"> My Experience </h2>

      <div className='container experience__container'>
        <div className='experience__frontend' data-aos="flip-left">
          <h3> Frontend Development </h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> HTML <AiFillHtml5 className='experience__details-icon' /> </h4> 
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> CSS <DiCss3 className='experience__details-icon' /></h4>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> React <DiReact className='experience__details-icon' /></h4>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> JavaScript <DiJavascript className='experience__details-icon' /></h4>
              </div>
            </article>
          </div>
        </div>
        <div className='experience__backend' data-aos="flip-right">
        <h3> Backend Development </h3>
          <div className='experience__content'>
           
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> Node JS <DiNodejsSmall className='experience__details-icon' /></h4>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> Mongo DB <SiMongodb className='experience__details-icon' /></h4>
              </div>
            </article>

            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
              <h4> PHP <SiPhp className='experience__details-icon' /></h4>
              </div>
            </article>
            </div>
        </div>
      </div>
    </section>
  )
}

export default Experience;